export const DaysPageInfo = {
  label: 'Days',
  title: 'Keep Track of your Drinking | Drink Agenda',
  path: '/days',
  description:
    'Count your drinks and track your alcohol consumption over time in just seconds each day.',
};
export const ReasonsPageInfo = {
  label: 'Reasons',
  title: 'Reasons to Drink Less Alcohol | Drink Agenda',
  path: '/reasons',
  description:
    'Track your motivation to manage your drinking. Improve relationships, live longer, and have a higher quality of life.',
};
export const GoalsPageInfo = {
  label: 'Goals',
  title: 'Set Personal Goals to Drink Less | Drink Agenda',
  path: '/goals',
  description:
    'Set the agenda for your alcohol consumption! Track weight loss, alcohol moderation, dry weeks and months, or total abstention. Let us help control your drinking.',
};
export const TacticsPageInfo = {
  label: 'Tactics',
  title: 'Tools and Techniques for Cutting Back | Drink Agenda',
  path: '/tactics',
  description:
    'Battle alcohol addiction and get control of your life with these helpful tools for anyone looking to reduce their alcohol consumption.',
};
export const ReportsPageInfo = {
  label: 'Reports',
  title: 'Visualize your Progress | Drink Agenda',
  path: '/reports',
  description:
    'Analyze your drinking to understand your relationship with alcohol! Detailed charts and graphs will help you track your progress to a better life.',
};
export const AccountPageInfo = {
  label: '',
  title: 'Account and Settings | Drink Agenda',
  path: '/account',
  description:
    'Manage, export, or delete your Drink Agenda data. Sign in/out and adjust settings.',
};
// ALSO UPDATE FIREBASE.JSON.
export const MainPages = [
  DaysPageInfo,
  ReasonsPageInfo,
  GoalsPageInfo,
  TacticsPageInfo,
  ReportsPageInfo,
  AccountPageInfo,
];

export const AboutPageInfo = {
  name: 'About',
  title: 'About | Drink Agenda',
  path: '/about',
  description: 'Learn how Drink Agenda can help you manage your alcohol intake',
};

export const PrivacyPageInfo = {
  name: 'Privacy',
  title: 'Privacy Policy | Drink Agenda',
  path: '/privacy',
  description: 'Drink Agenda respects your privacy',
};

export const FeedbackPageInfo = {
  name: 'Feedback',
  title: 'Feedback | Drink Agenda',
  path: '/feedback',
  description: 'Provide feedback on your Drink Agenda experience',
};

export const RewritePages = [
  ...MainPages,
  AboutPageInfo,
  PrivacyPageInfo,
  FeedbackPageInfo,
];
